import Rules from "../../views/carriersRules/Index.vue";

const RulesRoute = [
  {
    path: "/carrier-rules",
    name: "Rules",
    component: Rules,
  },
];

export default RulesRoute;
